module.exports = __webpack_public_path__ + "static/media/github-icon.09ea92d9.svg";